// ? Delete?
import React from 'react';
import { getLocalizedDetailedPagePath } from '../../affilate-logic/roche-ch';
import { LanguageService } from '../../services/language';
import { RocheUITextLink } from '@repo/roche-ui';

interface AvailableLanguagesProps {
  slot?: string;
  languages: Array<string>;
  slug: string;
  locale?: string;
}

export const AvailableLanguages = (props: AvailableLanguagesProps): JSX.Element => {
  let currentLanguage = props.locale ? props.locale : LanguageService.getActiveLanguage();
  let availableLanguages = props.languages.filter((language) => language !== currentLanguage);

  // See https://roche-ds.atlassian.net/browse/EXTCWP-550:
  // if the item has only one language, we link directly to that item in the language of the item.
  // In this case, we need to set available languages to an empty array.
  if (props.languages.length === 1) {
    availableLanguages = [];
    currentLanguage = props.languages[0];
  } else if (props.languages.length > 1 && !props.languages.includes(currentLanguage)) {
    // if we have multiple languages, but the current language is not available, we link to the item in the first
    // available language and make sure that the currently linked language is not shown in the list of available
    // languages.

    // if the item contains the default locale, we use it as the override
    if (props.languages.includes(LanguageService.getDefaultLocale())) {
      currentLanguage = LanguageService.getDefaultLocale();
    } else {
      // otherwise we use the first available language
      currentLanguage = props.languages[0];
    }
    availableLanguages = props.languages.filter((language) => language !== currentLanguage);
  }

  const links = availableLanguages.map((language) => (
    <span className='available-languages__language-switch' key={language} style={{ display: 'inline-flex' }}>
      <RocheUITextLink
        href={
          props.locale
            ? LanguageService.getLocaleAwareLink(
                `${getLocalizedDetailedPagePath(language)}/informationen/${props.slug}`,
                language,
              )
            : LanguageService.getLocaleAwareLink(props.slug, language)
        }
        text={language.toUpperCase()}
      />
    </span>
  ));

  if (!links.length) {
    return null;
  }

  return (
    <div slot={props.slot} style={{ display: 'inline-flex', alignItems: 'center' }}>
      <style>
        {`
          .available-languages__language-switch + .available-languages__language-switch::before {
            content: ' | ';
            white-space: pre;
          }
        `}
      </style>
      {links}
    </div>
  );
};
